import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { GlobalQuestionService } from "../../../../../swaggerServices";
import { IFormField } from "../../../../shared/components/form-field-wrapper/form-field-wrapper.component";
import { UntypedFormGroup } from "@angular/forms";
import { Subscription } from "rxjs";
import { ActivatedRoute } from "@angular/router";
import { Router } from "@angular/router";
import { ConfigStateService } from "../../../config/config-state.service";
import { Tenant } from "../../../../shared/types/tenant.enum";
import moment from 'moment';
import { ClientNotificationService } from '../../../client-notification.service';
import { environment } from '../../../../environments/environment'

declare var $: any;

const DISPLAY_DATE_FORMAT = "DD/MM/YYYY HH:mm";

interface IConfigExportQuestion extends IFormField {
  selected: boolean;
  displayUpdatedAt?: string;
  displayCreatedAt?: string;
  name: string;
  calcUpdatedAt: string;
}

@Component({
    selector: 'app-global-questions',
    templateUrl: './global-questions.component.html',
    styleUrls: ['./global-questions.component.scss'],
    standalone: false
})
export class GlobalQuestionsComponent implements OnInit, OnDestroy {
  loading: boolean;
  questions: IFormField[];
  @ViewChild('dropDown') dropDown: ElementRef;
  questionTypeFilter: any;
  questionSearch: string;
  @ViewChild('multiSelectDropdown') multiSelectDropdown: ElementRef;
  searchForm: UntypedFormGroup = new UntypedFormGroup({});
  subscriptions: Subscription[] = [];
  showQuestionId: boolean;
  configExportMode = false;
  entireListSelected = false;
  configExportDate = "";
  dateValidationRegex = new RegExp("^\\d{4}\\-(0[1-9]|1[012])\\-(0[1-9]|[12][0-9]|3[01])$");
  questionsForConfigExport: IConfigExportQuestion[];
  selectedQuestions = [];
  @ViewChild('configExportConfimationModal') configExportConfimationModal: ElementRef;
  isProductionMode: boolean;

  constructor(private questionService: GlobalQuestionService,
    public router: Router,
    private config: ConfigStateService,
    private activatedRoute: ActivatedRoute,
    private clientNotificationService: ClientNotificationService,
  ) {
    this.isProductionMode = environment.production
  }

  ngOnInit() {

    setTimeout(() =>
      $('.multi-select.dropdown').dropdown({
        placeholder: "All",
        preserveHTML: false,
      }));

    this.getQuestions();

    this.subscriptions.push(this.config.loadConfig().subscribe((config) => {
      this.showQuestionId = config.tenant !== Tenant.AU;
    }));
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getQuestions() {
    if (this.questions) return this.questions;

    this.loading = true;
    this.subscriptions.push(
      this.questionService.getGlobalQuestions()
        .subscribe((resp: any) => {
          this.questions = resp.questions.map(q => {
            return {
              ...q,
              questionType: this.getQuestionType(q)
            };
          });
          this.loadQuestionsForConfigExport()
          this.loading = false;
        }, () => {
          this.loading = false;
        })
    );
  }

  getQuestionType(q: IFormField): string {
    let questionType = q.displayFieldType;
    if (q.displayFieldType === 'text') {
      if (q.dataType === 'string') {
        questionType = 'text';
      } else if (q.dataType.toLowerCase() === 'integer' || q.dataType.toLowerCase() === 'float') {
        questionType = 'number';
      }
    }
    return questionType;
  };

  toggleConfigExportMode() {
    this.configExportMode = !this.configExportMode;
    if (!this.configExportMode) {
      setTimeout(() =>
        $('.multi-select.dropdown').dropdown({
          placeholder: "All",
          preserveHTML: false,
        }));
    }
  }

  entireListSelection() {
    this.questionsForConfigExport.forEach((q) => q.selected = this.entireListSelected);
  }

  listSelection() {    
    this.questionsForConfigExport.forEach((q) => {
      if (q.selected === false) return this.entireListSelected = false;
    })     
  } 

  loadQuestionsForConfigExport(ids?: string[]) {
    this.questionsForConfigExport = this.questions.map((q: any) => {
      if (ids && !ids.includes(q.id)) {
        return;
      }
      return {
        selected: false,
        displayCreatedAt: moment(q.createdAt).format(DISPLAY_DATE_FORMAT).toString(),
        displayUpdatedAt: moment(q.updatedAt).format(DISPLAY_DATE_FORMAT).toString(),
        name: q["calculationPlans.user.firstName"] ?
          `${q["calculationPlans.user.firstName"]} ${q["calculationPlans.user.lastName"]}` : "",
        calcUpdatedAt: q["calculationPlans.updatedAt"] ?
          moment(q["calculationPlans.updatedAt"]).format(DISPLAY_DATE_FORMAT).toString()
          : q["calculationPlans.user.firstName"] ? "" : "n/a",
        ...q
      }
    }).filter(q => q);
  }

  filterQuestionsOnDateChange() {
    if (!this.configExportDate.length) {
      this.loadQuestionsForConfigExport();
      return;
    }
    if (this.dateValidationRegex.test(this.configExportDate)) {
      this.loading = true;
      this.questionService.getUpdatedGlobalQuestionByDate(this.configExportDate).subscribe((ids) => {
        this.loading = false;
        this.loadQuestionsForConfigExport(ids);
      });
    }
  }

  openConfigExportConfimationModal() {
    this.selectedQuestions = this.questionsForConfigExport.map((q) => {
      if (q.selected) { return { id: q.id, question: q.question, displayUpdatedAt: q.displayUpdatedAt } }
    }).filter(tt => tt);
    $(this.configExportConfimationModal.nativeElement).modal("show");
    $(this.configExportConfimationModal.nativeElement).scrollTop($(this.configExportConfimationModal.nativeElement)[0].scrollHeight);
  }

  clearSelectedSources() {
    this.questionsForConfigExport.forEach((q) => q.selected = false);
  }

  downloadConfig() {
    if (!this.selectedQuestions.length) { return; };
    const globalQuestionIds = this.selectedQuestions.map(q => q.id);
    this.questionService.downloadConfigExportGlobalQuestion({ globalQuestionIds }).subscribe(data => {
      if (!data.fileContent) {
        this.clientNotificationService.appendMessage("File couldn't be fetched, please try again later", "Download config", false);
        return;
      }
      var elem = window.document.createElement('a');
      elem.href = "data:application/json," + encodeURIComponent(data.fileContent);
      elem.download = data.fileName ? data.fileName : "package";
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
      this.clearSelectedSources();
      $(this.configExportConfimationModal.nativeElement).modal("hide");
    }, error => {
      $(this.configExportConfimationModal.nativeElement).modal("hide");
    })
  }
}
